export default __webpack_public_path__ + "static/media/pic12.a21c7500.jpg";